// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";

import { alertsClasses as myClasses } from "../../";

import { Classes } from "src/mpd-library";

import { ChannelBox, ChannelBoxTypes } from "../";

import { HTMLDivProps, Text } from "@blueprintjs/core";

import "./styles.css";

export interface IMultiMediaInActiveProps extends HTMLDivProps {
  multiMedia: any;
  onMultiMediaClicked(event: any, type: string, status: string): void;
}

export class MultiMediaInActive extends React.Component<
  IMultiMediaInActiveProps
> {
  public render() {
    const { className, onMultiMediaClicked, multiMedia } = this.props;

    const { state } = multiMedia;

    const classes = classNames(
      "multimedia-inactive",
      state === "init" && Classes.ACTIVE,
      className
    );
    return (
      <div className={classes}>
        <Text className={myClasses.ALERTS_CONTENT_COMPOSE_SUBTITLE}>
          MULTIMEDIA
        </Text>
        <div className={myClasses.ALERTS_CONTENT_COMPOSE_CHANNEL_BOX_CONTAINER}>
          <ChannelBox
            onClick={e => onMultiMediaClicked(e, "image/*", "image")}
            title="Add Photo"
            id={"add-photo"}
            type={ChannelBoxTypes.multimedia}
            name="photo"
          />
          <ChannelBox
            onClick={e => onMultiMediaClicked(e, "video/*", "video")}
            title="Add Video"
            type={ChannelBoxTypes.multimedia}
            id={"add-video"}
            name="video"
          />
          <ChannelBox
            onClick={e =>
              onMultiMediaClicked(
                e,
                ".doc, .docx,.ppt, .pptx,.txt,.pdf",
                "document"
              )}
            title="Add Document"
            type={ChannelBoxTypes.multimedia}
            id="add-document"
            name="document"
          />
          <ChannelBox
            onClick={e => onMultiMediaClicked(e, "audio/*", "audio")}
            title="Add Voice"
            type={ChannelBoxTypes.multimedia}
            id={"add-voice"}
            name="voice"
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/multimedia/multimedia-inactive.tsx